module.exports = __webpack_public_path__ + "static/media/delete_icon.3913c7ce.svg";